import { useState, useEffect, useReducer } from "react";
import { useParams } from "react-router-dom";
import ScrollView from "devextreme-react/scroll-view";

import * as dashboardActions from "../../actions/dashboard";
import dashboardReducer from "../../reducers/dashboard";
import { postUserLog } from "../../actions/common";

const initialState = {
  gembaWalkPrioritiesData: [],
};

const GembaWalkPriorities = ({ andonTitle, navigationTabOn }) => {
  const [state, dispatch] = useReducer(dashboardReducer, initialState);
  const [scrollConfig] = useState({
    showScrollbar: "always",
    scrollByContent: true,
    scrollByThumb: true,
  });
  const [showDetails, setShowDetails] = useState([]);

  const { tier, site } = useParams();

  let { gembaWalkPrioritiesData } = state;

  const CLRS = [
    "",
    "linear-gradient(180deg, rgba(27,148,33,1) 0%, rgba(9,115,11,1) 35%, rgba(26,67,28,1) 75%)",
    "linear-gradient(180deg, rgba(194,2,2,1) 0%, rgba(169,5,5,1) 35%, rgba(116,12,12,1) 75%)",
    "#666",
    "black",
  ];

  useEffect(() => {
    dashboardActions.getGembaWalkPriorities(dispatch, tier);
  }, []);

  const getUniqueShiftNumbers = (gembaWalkData) => {
    const uniqueShiftNames = new Set([]);
    gembaWalkData.map((shiftData) => {
      shiftData.cards.map((shifts) => {
        const shiftNumber = shifts.shift.split(" ")[1];
        uniqueShiftNames.add(shiftNumber);
      });
    });
    return [...uniqueShiftNames];
  };

  const getWidgetTitle = (gembaWalkData) => {
    const shiftNumbers = getUniqueShiftNumbers(gembaWalkData);
    let title = ": ";

    switch (true) {
      case shiftNumbers.length == 2:
        shiftNumbers.map((num, i) => {
          title += `Shift ${num} ${shiftNumbers.length != i + 1 ? "& " : ""}`;
        });
        break;
      case shiftNumbers.length > 2:
        shiftNumbers.map((num, i) => {
          title += `Shift ${num} ${shiftNumbers.length != i + 1 ? ", " : ""}`;
        });
        break;
      case shiftNumbers.length === 1:
        shiftNumbers.map((num, i) => {
          title += `Shift ${num}`;
        });
        break;
      default:
        title = "";
    }
    return title;
  };

  return (
    <div className="gemba-walk-container">
      <div className="col-heading">
        Gemba Walk Priorities {getWidgetTitle(gembaWalkPrioritiesData)}
        {andonTitle}
      </div>
      {gembaWalkPrioritiesData.length >= 1 ? (
        <ScrollView
          id="sitecontent"
          {...scrollConfig}
          height={500}
          direction="vertical"
        >
          <div>
            {gembaWalkPrioritiesData &&
              gembaWalkPrioritiesData.map(
                (smessCard, i) =>
                  smessCard.tierid !== null && (
                    <div className="gemba-walk-cards" style={{}}>
                      <div
                        className="cards side-cards"
                        style={{ background: CLRS[4], color: "#fff" }}
                      >
                        <div style={{ textAlign: "center" }}>
                          {`${
                            smessCard.cards[0].shift
                              ? `Shift ${
                                  smessCard.cards[0].shift.split(" ")[1]
                                } : `
                              : ""
                          }`}{" "}
                          {smessCard.tierName}
                        </div>
                        {smessCard.missCount !== 5 && (
                          <div
                            onClick={() => {
                              const showCard = [...showDetails];
                              if (showCard.includes(i)) {
                                setShowDetails(
                                  showCard.filter((num) => num !== i)
                                );
                                postUserLog({
                                  event: `SMESS Summary`,
                                  data: {
                                    action: `Show details unselected for ${
                                      smessCard.cards[0].shift
                                        ? `Shift ${
                                            smessCard.cards[0].shift.split(
                                              " "
                                            )[1]
                                          } : `
                                        : ""
                                    }${smessCard.tierName}`,
                                    module: "Digital Tier",
                                    section: navigationTabOn,
                                    siteUId: site,
                                    widget: "SMESS",
                                    tierId: tier,
                                  },
                                });
                              } else {
                                showCard.push(i);
                                setShowDetails(showCard);
                                postUserLog({
                                  event: `SMESS Summary`,
                                  data: {
                                    action: `Show details selected for ${
                                      smessCard.cards[0].shift
                                        ? `Shift ${
                                            smessCard.cards[0].shift.split(
                                              " "
                                            )[1]
                                          } : `
                                        : ""
                                    }${smessCard.tierName}`,
                                    module: "Digital Tier",
                                    section: navigationTabOn,
                                    siteUId: site,
                                    widget: "SMESS",
                                    tierId: tier,
                                  },
                                });
                              }
                            }}
                            className="my-anchor-css-class show-more-btn"
                          >
                            {!showDetails.includes(i)
                              ? `...Show Details`
                              : `Hide Details...`}
                          </div>
                        )}
                      </div>
                      {smessCard.cards.map((card) => (
                        <>
                          <div
                            key={i}
                            className="cards"
                            style={{ background: CLRS[card.status] }}
                          >
                            <div style={{ textAlign: "center" }}>
                              {card.title}
                            </div>
                            {showDetails.includes(i) &&
                              card.reasonCode &&
                              card.reasonCode[0].id !== null && (
                                <div
                                  style={{
                                    fontSize: "10px",
                                    marginTop: "5px",
                                    width: "95px",
                                    background: "rgba(16 15 15 / 20%)",
                                    maxHeight: "70%",
                                    minHeight: "63%",
                                    width: "90%",
                                    borderRadius: "6px",
                                    marginBottom: "5px",
                                  }}
                                >
                                  <div
                                    style={{
                                      textAlign: "center",
                                      fontSize: "10px",
                                      color: "grey",
                                    }}
                                  >
                                    Description
                                  </div>
                                  <br />
                                  {card.reasonCode.length > 1 &&
                                    card.reasonCode.map((reasonDetail) => (
                                      <>
                                        <div
                                          className="txt-episis"
                                          style={{ marginLeft: "3px" }}
                                        >
                                          {reasonDetail.reasonCode}
                                        </div>
                                        <br />
                                      </>
                                    ))}
                                  {card.reasonCode.length == 1 &&
                                    card.reasonCode.map((reasonDetail) => (
                                      <div style={{ marginLeft: "3px" }}>
                                        {reasonDetail.reasonCode}
                                      </div>
                                    ))}
                                </div>
                              )}
                          </div>
                        </>
                      ))}
                      <div
                        key={i}
                        className="cards side-cards"
                        style={{ background: CLRS[4], color: "#fff" }}
                      >
                        {smessCard.missCount}
                      </div>
                    </div>
                  )
              )}
          </div>
        </ScrollView>
      ) : (
        <div
          style={{
            minHeight: "80px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span>No Data Available To Display</span>
        </div>
      )}
    </div>
  );
};
export default GembaWalkPriorities;
